import { App } from 'vue'
import tinycolor from 'tinycolor2'

export default {
  install: (app: App<Element>) => {
    const vue = app
    vue.config.globalProperties.$textColorFromHex = (hex: any) => (tinycolor(hex).isDark() ? 'white' : 'black')
  }
}